import React, {useEffect} from 'react';
import {
	Typography,
	Grid
} from "@material-ui/core";
import { useStyles } from "../../../hooks";
import styles from "./styles";
import { PUBLICURL } from "../../../main_config";
import LinkEcco from "../../Link";
import {useDispatch} from "react-redux";
import { clearDataScheduler } from '../../../redux/actions/hireActions'

const SuccessfulHiring = ({...props}) => {
	const userByDoc = props?.location?.state?.userByDoc
	const userByEmail = props?.location?.state?.userByEmail
	const emailTitular = props?.location?.state?.emailTitular
	const status = props?.location?.state?.status
	const envioMail = props?.location?.state?.envioMail
	const classes = useStyles(styles);
	const dispatch = useDispatch();

	const TypographyProps = {
		component: "h2",
		gutterBottom: true,
		color: "primary",
		align: "center"
	};

	const TypographyTextProps = {
		component: "h4",
		gutterBottom: true,
		color: "gray",
		align: "center"
	};

	useEffect(()=> {
        dispatch(clearDataScheduler())
    },[])

	return (
		<Grid container className={classes.container}>
			<Grid container direction="row"
				justifyContent="center"
				alignItems="center"
			>
				<Typography
					{...TypographyProps}
					className={classes.title}

				>
					Ya contás con la mejor Cobertura en Emergencias y Urgencias
			</Typography>
			</Grid>

			<Grid container direction="row"
				justifyContent="center"
				alignItems="center"
				className={classes.containerImg}
			>

				<img
					src={`${PUBLICURL}/assets/images/hire/HireSuccess.png`}
					alt="Exito"
				/>
			</Grid>

			<Grid container direction="flex-start"
				justifyContent="center"
				alignItems="center"
				className={classes.containerText}>

				<Grid xs={9} md={5} lg={5}>
					<Typography
						{...TypographyTextProps}
					>
						 Tu número de contrato es <b>{props?.location?.state?.nroContrato ?props.location.state.nroContrato.trim():null}</b>.
						Este número te permitirá registrarte en nuestro sitio web y acceder al servicio.
					</Typography>
				
				{status === 200 && envioMail === true ? 

					  userByDoc !== null ?
					<Typography
						{...TypographyTextProps}
					>
						Accedé al sitio, haciendo click&nbsp; 
						<LinkEcco
						    external={true}
							to={`/login#/`}
							underline="hover"
							align="center"
							target="_blank"
						>
						acá
						</LinkEcco>
						. Si no recordás tu contraseña hacé click&nbsp; 
						<LinkEcco
						    external={true}
							to={`/login#/recuperar-cuenta`}
							underline="hover"
							align="center"
							target="_blank"
						>
						acá
						</LinkEcco>
						. El mail con el que ya estás registrado es <b>{userByDoc?.email ? userByDoc.email : ""}</b>
					</Typography> 

					:  userByEmail !== null ? 
							<Typography
								{...TypographyTextProps}
							>
								Podés registrarte en el sitio, haciendo click&nbsp; 
								<LinkEcco
									external={true}
									to={`/panel#/registracion`}
									underline="hover"
									align="center"
									target="_blank"
								>
								acá
								</LinkEcco>
							</Typography>
							: 
							<Typography
							{...TypographyTextProps}
							>
								Se envió al correo electronico <b>{emailTitular}</b> un email con un link para que puedas registrarte en el sitio	
							</Typography>	
					: 
					<>
					<Typography
						{...TypographyTextProps}
					>
						Podés registrarte en el sitio, haciendo click&nbsp; 
						<LinkEcco
							external={true}
							to={`/panel#/registracion`}
							underline="hover"
							align="center"
							target="_blank"
						>
						acá
						</LinkEcco>
					</Typography>
					<Grid
						container
						direction="column" align="center" justifyContent="center" alignContent="center"
					>
					<LinkEcco
						external={true}
						url="https://www.ecco.com.ar/virtualhosts/eccoindividuales/documentos/Carta_Bienvenida_ns.pdf"
						href="https://www.ecco.com.ar/virtualhosts/eccoindividuales/documentos/Carta_Bienvenida_ns.pdf"
						target="_blank"
						underline="hover"
						>
							Carta de bienvenida
					</LinkEcco>
					
					<LinkEcco
						external={true}
						url="https://www.ecco.com.ar/virtualhosts/eccoindividuales/documentos/Instructivo_activaci%C3%B3n_de_servicio.pdf"
						href="https://www.ecco.com.ar/virtualhosts/eccoindividuales/documentos/Instructivo_activaci%C3%B3n_de_servicio.pdf"
						target="_blank"
						underline="hover"
						>Instructivo
						de activación de servicio
					</LinkEcco>
					<LinkEcco
						external={true}
						url="https://www.ecco.com.ar/virtualhosts/eccoindividuales/assets/images/APP_Mobile_ECCO.jpg"
						href="https://www.ecco.com.ar/virtualhosts/eccoindividuales/assets/images/APP_Mobile_ECCO.jpg"
						target="_blank"
						underline="hover"
						>APP
						Mobile ECCO
					</LinkEcco>
					<LinkEcco
						external={true}
						url="https://www.ecco.com.ar/virtualhosts/eccoindividuales/documentos/Tel%C3%A9fono_Emergencia_Formas_de_Pago.pdf"
						href="https://www.ecco.com.ar/virtualhosts/eccoindividuales/documentos/Tel%C3%A9fono_Emergencia_Formas_de_Pago.pdf"
						target="_blank"
						underline="hover"
						>Información
						importante
					</LinkEcco>
					<LinkEcco
						external={true}
						url="https://www.ecco.com.ar/virtualhosts/eccoindividuales/assets/images/Credencial_ECCO.png"
						href="https://www.ecco.com.ar/virtualhosts/eccoindividuales/assets/images/Credencial_ECCO.png"
						target="_blank"
						underline="hover"
						>Credencial
						ECCO
					</LinkEcco>
					</Grid>
					</>
					}
					{ status === 200 && envioMail === true &&
					<>
					<Typography
						{...TypographyTextProps}
					>
						<br></br>
						En los próximos minutos recibirás un correo con más información.
						</Typography>
					<Typography
						{...TypographyTextProps}
					>
						(Si no lo ves en tu bandeja de entrada, revisá tu correo no deseado).
						</Typography>
					</>}
				</Grid>
			</Grid>
		</Grid>
	);
}

export default SuccessfulHiring;